import React from "react";
import { HexpertResultVideoImages } from "../../types/hexpertResultTypes";
import './ProductImages.scss';

type ProductImagesProps = {
  title : any;
  mainImage?: any;
  extraImages?: HexpertResultVideoImages[];
};

export const ProductImages = ({ title, mainImage, extraImages }: ProductImagesProps) => {
  return mainImage ? (
    <div className="c-hex-result-images">
      <div className="c-hex-result-images-main">
        <img src={mainImage} alt={title} />
      </div>
      {extraImages && extraImages?.length > 0 && (
        <div className="c-hex-result-images-extra">
          {extraImages?.map((img, i) =>
            img?.Url.includes("youtube") ? null : (
              <div key={i} className="c-hex-result-images-extra-image">
                <img src={img?.Url} alt={title} />
              </div>
            )
          )}
        </div>
      )}
    </div>
  ) : null;
};
